module.exports = __webpack_public_path__ + "img/mpu-vorbereitungskurs-online.b5ba0594.jpg";